import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getTemplesFromDirectory } from '../services/templeService'
import useNotifications from './useNotifications'

/**
 * Hook for fetching a specific artifact
 * @param {number} artifactId ID to fetch
 * @returns {Object} object with loading boolean, error status/data, artifact object, and refetch function
 */
const useTempleDirectory = () => {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [temples, setTemples] = useState()

  useEffect(() => {
    if (!temples) {
      getTemplesFromDirectory()
        .then((templesData) => {
          const map = {}
          templesData.forEach((temple) => {
            map[temple.code] = temple
          })
          setTemples(map)
        })
        .catch((err) => {
          setTemples(null)
          error(
            t('hooks.errors.gettingTemples', {
              defaultValue: `Error getting temples: ${err.message || ''}`,
              message: err.message || '',
            }),
            err
          )
        })
    }
  }, [error, temples, t])

  return { temples }
}

export default useTempleDirectory
